import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Form, Schema } from 'rsuite';
import designService from '../../../../../services/Internal/Renewal/PE/design.service';
import Information from '../../../../Shared/Card/Information';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons';
import RedStar from '../../../../Shared/GenericComponents/RedStar';
import { GetRenewalInformationContent } from '../../../../Shared/InformationContent/PeInformation';
import YesNoRadioOption from '../../../../Shared/RadioButton/YesNoRadioOption';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import peRenewalService from '../../../../../services/Internal/Renewal/PE/peRenewal.service';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import Issues from '../../../../Shared/Card/Issues';
import renewalService from '../../../../../services/Internal/Renewal/renewal.service';
import FormEntityInformation from '../../../Shared/FormEntityInformation';

function BuildingDesignPage() {
    const renewalId = useSelector(x => x.currentApplicationId);
    const entityId = useSelector(x => x.userInfo.EntityId)
    const [hasLoaded, setHasLoaded] = useState(false);
    const year1 = new Date().getFullYear() - 2;
    const year2 = new Date().getFullYear() - 1;
    const [isBuildingdesignRequired, setIsBuildingdesignRequired] = useState(true);
    const [isLicenseStatusSet, setIsLicenseStatusSet] = useState(true);
    const [isLicenseStatusNonactiveToActive, setIsLicenseStatusNonactiveToActive] = useState(false);
    const [model, setModel] = useState({
        hasLaBuildingDesign: '',
        hasSafetyCodeHours: '',
        renewalId: renewalId,
        entityId: entityId
    });
    const push = useNavigate();
    const sectionId = 10;
    const routes = useSelector(x => x.currentRoutes);
    const [sectionData, setSectionData] = useState({});
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Professional Engineer Renewal",
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "Building Design"
        }
    );
    useEffect(() => {
        peRenewalService.peGetSection(renewalId, sectionId).then((data) => {
            setSectionData(data.data);
            renewalService.getIndividualRenewal(renewalId).then((renewalData) => {
                setIsUserEditable(renewalData.data.status.id == 2)
                entityService.getEntity(data.data.entityId).then((entity) => {
                    setEntityInfo(
                        {
                            ...entityInfo,
                            lolaNum: entity.data.lolaNumber,
                            entityName: entity.data.formattedName,
                            entityId: entity.data.entityId,
                            licenseNumber: renewalData.data?.credential?.formattedLicenseNumber,
                            applicationDate: renewalData.data?.dateSubmitted
                        })
                });
            });
            setIsComplete(data.data.staffReviewComplete)
            designService.isBuildingDesignRequired(renewalId).then((result) => {//if result is null, no status was chosen
                if (result.data) {
                    designService.getBuildingDesign(renewalId).then((response) => {
                        if (response.data)
                            setModel({
                                ...response.data
                            })
                        designService.isNonactiveToActive(renewalId).then((status) => setIsLicenseStatusNonactiveToActive(status.data));
                        setHasLoaded(true);

                    })
                }
                else if (result.data === false) {
                    setIsBuildingdesignRequired(false)
                    setHasLoaded(true)
                }
                else {
                    setIsLicenseStatusSet(false)
                    setHasLoaded(true)
                }
            })
        })
    }, [])
    const { BooleanType } = Schema.Types;
    const validationModel = Schema.Model({
        hasLaBuildingDesign: BooleanType().isRequired("This field is required."),
        hasSafetyCodeHours: BooleanType().when(schema => {
            return model.hasLaBuildingDesign ? BooleanType().isRequired("This field is required.") : BooleanType()
        })
    });
    const formSubmit = (val, event) => {
        var dataToTransmit = { ...model };
        if (model.hasLaBuildingDesign == false) {
            dataToTransmit = { ...model, hasSafetyCodeHours: null };
        }
        designService.postBuildingDesign(dataToTransmit).then((response) => {
            if (response.data)
                peRenewalService.peMarkSectionComplete(renewalId, sectionId, isComplete).then((data) => {
                    nextSectionNavigation();
                })
        })
    }

    const notRequiredSubmit = (event) => {
        peRenewalService.peMarkSectionComplete(renewalId, sectionId, isComplete).then((data) => {
            nextSectionNavigation();
        })
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
    }
    return (
        <div className="peRenewalDesignPage">
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Information content={GetRenewalInformationContent("design")} />
                <br />
                {hasLoaded ? !isLicenseStatusSet ?
                    <Form onSubmit={notRequiredSubmit}>
                        <Card>
                            <Card.Header>
                                <h5>Building Design in Louisiana</h5>
                            </Card.Header>
                            <Card.Body>
                                <span>Please go back and choose a license status to renew into before completing this section. You may access that section by clicking the "Back to Sections" button at the bottom of the page.</span>
                            </Card.Body>
                        </Card>
                        <br />
                        <Issues isUserEditable={isUserEditable} isInternal={true} type={3} sectionId={sectionData.id} setIsComplete={setIsComplete} />
                        <FormActionButtons
                            isUserEditable={isUserEditable}
                            showSectionComplete={true}
                            isComplete={isComplete}
                            isCompleteCallback={setIsComplete} backToSectionLink="/internal/perenewal/sections" />
                    </Form> : isBuildingdesignRequired ?
                        <Form formValue={model} onSubmit={formSubmit} onChange={setModel} model={validationModel} >
                            <Card>
                                <Card.Header><h6>Building Design in Louisiana</h6></Card.Header>
                                <Card.Body>
                                    {isLicenseStatusNonactiveToActive ?
                                        <p className="mb-3"><RedStar /> Have you designed buildings or building systems in Louisiana since your license was no longer in Active status?</p> :
                                        <p className="mb-3"><RedStar /> Have you designed buildings or building systems in Louisiana since your last renewal?</p>}
                                    <YesNoRadioOption isReadOnly={!isUserEditable} radioName="hasLaBuildingDesign" />
                                    {model.hasLaBuildingDesign == true && <>
                                        <hr />
                                        <h6 className="mb-3">Safety Code Hours</h6>
                                        <p className="mb-3">Do you have 4 PDH’s of Life Safety Code, building codes, and/or Americans with Disabilities Act Accessibility Guidelines <strong>per calendar year(s)</strong> when you designed buildings or buildings systems in Louisiana?</p>
                                        <YesNoRadioOption isReadOnly={!isUserEditable} radioName="hasSafetyCodeHours" /></>}
                                </Card.Body>
                            </Card>
                            <br />
                            <Issues isUserEditable={isUserEditable} isInternal={true} type={3} sectionId={sectionData.id} setIsComplete={setIsComplete} />
                            <FormActionButtons
                                isUserEditable={isUserEditable}
                                showSectionComplete={true}
                                isComplete={isComplete}
                                isCompleteCallback={setIsComplete} backToSectionLink="/internal/perenewal/sections" />
                        </Form>
                        : <Form onSubmit={notRequiredSubmit}>
                            <Card>
                                <Card.Header>
                                    <h5>Building Design in Louisiana</h5>
                                </Card.Header>
                                <Card.Body>
                                    <span>Due to the license status chosen at the beginning of this renewal, this section is not required. You may click "Next Section" to continue your renewal.</span>
                                </Card.Body>
                            </Card>
                            <br />
                            <Issues isUserEditable={isUserEditable} isInternal={true} type={3} sectionId={sectionData.id} setIsComplete={setIsComplete} />
                            <FormActionButtons
                                isUserEditable={isUserEditable}
                                showSectionComplete={true}
                                isComplete={isComplete}
                                isCompleteCallback={setIsComplete} backToSectionLink="/internal/perenewal/sections" />
                        </Form> : <LoadingSpinner />
                }
            </Container >
        </div >
    )
}
export default BuildingDesignPage;